import registerWithErrorBoundary from '@utils/registerWithErrorBoundary';

import Home from '@components/pages/Home';

registerWithErrorBoundary({
  Home,
});
